import React from 'react'
import './AdminSideBar.css'
import { Link } from 'react-router-dom'

export default function AdminSideBar() {
  return (
    <div className='adminside-container'>
        <h1 className='adminside-h1'>پنل مدیریت</h1>
        <hr style={{width:'80%',color:' rgb(188, 160, 154)'}}/>
        <ul className='adminside-ul'>
          <li className='adminside-li  controll2 arrow_icon2'>دوایر <ul className='Davayer-ul' >
            <Link className='adminside-davayerlink' to={'/circlelist'}><li>لیست دوایر</li></Link>
            <Link className='adminside-davayerlink' to={'/addcircle'}><li>افزودن دایره</li></Link>
            
            </ul></li>
        </ul>
        <hr style={{width:'80%',color:' rgb(188, 160, 154)'}}/>

      
    </div>
  )
}
